import React from 'react';
import { ReactComponent as IconFacebook } from './assets/icons/facebook.svg';
import { ReactComponent as IconTwitter } from './assets/icons/twitter.svg';
import { ReactComponent as IconGithub } from './assets/icons/github.svg';
// import "./App.css";
import "./landing.css";

class App extends React.Component {
  render = () => {
    return (
      <div className="card">
        <div className="header">
          <div className="logo">
            <a href=".">VeVerse</a>
          </div>
          <div className="social">
            <a href="https://facebook.com/veverse.metaverse" title="Facebook" target="_blank" rel="noopener noreferrer">
              <IconFacebook className="icon" />
            </a>
            <a href="https://twitter.com/veversedao" title="Twitter" target="_blank" rel="noopener noreferrer">
              <IconTwitter className="icon" />
            </a>
            <a href="https://github.com/veverse-metaverse" title="GitHub" target="_blank" rel="noopener noreferrer">
              <IconGithub className="icon" />
            </a>
          </div>
        </div>
        <div className="content">
          <div className="title-holder">
            <h1>Get ready for the change.</h1>
            <p>Website coming soon. Please check back to know more. Shoot us an email if you're curious.</p>
          </div>
          <a href="mailto:v@veverse.com">
            <div className="cta">Send us an email</div>
          </a>
        </div>
        <div className="footer">
          <span>OWN YOUR<a className="underlined" href="https://veverse.com" target="_blank" rel="noopener noreferrer"> METAVERSE</a></span>
        </div>
      </div>
    );
  }
}

export default App;